import { dateTimeFormat, DATETIME_ELEMENT_STYLES } from '@fiverr-private/localization';

/**
 * From Seconds to MilliSeconds - Multiply by 1000
 * From MilliSeconds to Seconds - Divide by 1000
 * **/
const MILLI_SECONDS_IN_SECONDS = 1000;

/**
 * Returns formatted date according to timestamp. For example for
 * the timestamp `1623246577` we will receive `Jun 9, 2021`.
 * @param {number} timestampInSeconds - epoch unix time in seconds.
 * @returns {string}
 */
export const formatDate = (timestampInSeconds) =>
    dateTimeFormat({
        value: timestampInSeconds * MILLI_SECONDS_IN_SECONDS,
        options: { dateStyle: DATETIME_ELEMENT_STYLES.LONG },
    });
